module.exports = __webpack_public_path__ + "img/gh-30282.asm.e215544d.jpg";